import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable()
export class SolutionMasterQueryService {
    public GET_CLIENT_REPORT_BASED_ON_ORDERID: any;
    public DELETE_CLIENT_REPORT_REVIEW_DATA:any;
    public DELETE_CLIENT_REPORT_REVIEW_DATA_WITHOUT_STATUS:any;
    public GET_CLIENT_REPORT_BASED_ON_ORDERID_STATUS:any;
    public CREATE_REPORT_SOLUTION_MASTER :any ; 

    constructor(public apollo: Apollo) {
      this.GET_CLIENT_REPORT_BASED_ON_ORDERID_STATUS =    gql`     
      query getReportSolutionMasters($orderId:Int!){                           
        allReportSolutionMasters(condition:{orderId:$orderId},orderBy:REVIEW_ID_ASC) {
          edges {
            node {
              id
              reviewedBy
              createdAt
              insReportId
              reviewId
              acceptStatus
              allocated
              orderId
              expectedDate
              buyerProperty
              reportReviewDetailByReviewId {
                nodeId
                id
                categoryId
                subCategoryId
                createdAt
                modifiedAt
                totalCost
                labourCost
                description
                materialCost
                resourceLink
                categoryName
                subCategoryName
                orderId
                solution
                imagePath
                solCategory
                solSubCategory
                insReportId
                itemNumWc
                costOption
              }
            }
          }
        } 
    }
  `;
        //Get client reports from report master file
        this.GET_CLIENT_REPORT_BASED_ON_ORDERID =
            gql`     
            query getReportSolutionMasters($orderId:Int!){                           
              allReportSolutionMasters(condition:{orderId:$orderId,acceptStatus:true},orderBy:REVIEW_ID_ASC) {
                edges {
                  node {
                    id
                    reviewedBy
                    createdAt
                    insReportId
                    reviewId
                    acceptStatus
                    allocated
                    orderId
                    expectedDate
                    buyerProperty
                    reportReviewDetailByReviewId {
                      beforeAndAfterRepairPicturesByReviewId{
                        nodes{
                          reviewId
                          beforeRepair
                        }
                      }
                      reviewId
                      nodeId
                      id
                      categoryId
                      subCategoryId
                      createdAt
                      modifiedAt
                      totalCost
                      labourCost
                      description
                      materialCost
                      resourceLink
                      categoryName
                      subCategoryName
                      orderId
                      solution
                      imagePath
                      solCategory
                      solSubCategory
                      insReportId
                      itemNumWc
                      costOption
                      ni
                      cpi
                      cpf
                      tf
                      hourRate
                      laborHour
                      shoppingMaterials
                      materialList
                    }
                  }
                }
              } 
          }
        `;

        this.DELETE_CLIENT_REPORT_REVIEW_DATA = gql`     
        mutation DELETE_REPORT_SOLUTION_MUTATION($input:DeleteReportSolutionMasterByIdInput!){
          deleteReportSolutionMasterById(input:$input) {
                       deletedReportSolutionMasterId
          }
       }
      `;

        // Mutation - Create report  solution
    this.CREATE_REPORT_SOLUTION_MASTER = gql` 
    mutation CREATE_REPORT_SOLUTION_MASTER($input: CreateReportSolutionMasterInput!) {
         createReportSolutionMaster(input: $input) {
             reportSolutionMaster{   
                 insReportId         
             }
        }
    }
    `;


    }
    GET_ACCEPTED_REPORTS(orderId): any {
        return this.apollo
            .watchQuery({
                query: this.GET_CLIENT_REPORT_BASED_ON_ORDERID
                ,
                variables:
                {
                    "orderId": Number.parseInt(orderId),
                },
                fetchPolicy: 'network-only'
            });
    }

    GET_ACCEPTED_REPORTS_WITHOUT_STATUS(orderId): any {
      return this.apollo
          .watchQuery({
              query: this.GET_CLIENT_REPORT_BASED_ON_ORDERID_STATUS
              ,
              variables:
              {
                  "orderId": Number.parseInt(orderId),
              },
              fetchPolicy: 'network-only'
          });
  }

    DELETE_CLIENT_REPORT_REVIEW(category) {
      console.log("category from query file",category);

      return this.apollo.mutate({
          mutation: this.DELETE_CLIENT_REPORT_REVIEW_DATA,
          variables: {
              "input": {
                  "id": category.id
              }
          }
      })
  }

    // Insert report details
    insertReport(report,expectedDate,buyerProperty): any {
      return this.apollo.mutate({
        mutation: this.CREATE_REPORT_SOLUTION_MASTER,
        variables: {
          'input': {
            'reportSolutionMaster': {
              'createdAt': new Date(),
              'insReportId': report.insReportId,
              'reviewId': report.reviewId,
              'acceptStatus': report.accept,
              'allocated': false, // check if needed
              'orderId': Number(report.orderId),
              'expectedDate': expectedDate,
              'buyerProperty': buyerProperty
            }
          },
  
        }
      });
    }


}


// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/queryFiles/reportSolutionMaster.ts